// See @store/AppPhaseStore.ts for the store loading order.
// Shared axios instance for all API calls. Uses a request interceptor to attach
// the current session token on every request, so consumers don't manage auth headers.

import { create } from 'zustand';
import axios, { type AxiosInstance } from 'axios';
import { getSessionStore } from './SessionStore';

type ApiClientStore = {
    apiClient: AxiosInstance;
};

const apiClient = axios.create({
    baseURL: '/api/',
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
    const { token } = getSessionStore();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const useApiClientStore = create<ApiClientStore>(() => ({
    apiClient,
}));

export const getApiClient = () => useApiClientStore.getState().apiClient;
